import { axios } from "~/plugins/request"
export const state = () => {
  return {}
}
export const mutations = {}
export const actions = {
	getCourseList({ commit }, params) {
		return new Promise((resolve, reject) => {
		  axios.post('courseStudy/getCourseList', params)
			.then(response => {
			  resolve(response)
			})
			.catch(error => {
			  reject(error)
			})
		})
	},
	getAllCourseList({ commit }, params) {
		return new Promise((resolve, reject) => {
		  axios.post('courseStudy/getAllCourseList', params)
			.then(response => {
			  resolve(response)
			})
			.catch(error => {
			  reject(error)
			})
		})
	},
	courseFeedBackSave({ commit }, params) {
	  return new Promise((resolve, reject) => {
	    axios.post('courseFeedBack/save', params)
	      .then(response => {
	        resolve(response)
	      })
	      .catch(error => {
	        reject(error)
	      })
	  })
	},
	updateEvaluate({ commit }, params) {
	  return new Promise((resolve, reject) => {
	    axios.post('courseStudy/updateEvaluate', params)
	      .then(response => {
	        resolve(response)
	      })
	      .catch(error => {
	        reject(error)
	      })
	  })
	},
	listFeedBack({ commit }, params) {
	  return new Promise((resolve, reject) => {
	    axios.post('courseFeedBack/list_feed_back', params)
	      .then(response => {
	        resolve(response)
	      })
	      .catch(error => {
	        reject(error)
	      })
	  })
	},
	getCourseStudy({ commit }, params) {
	  return new Promise((resolve, reject) => {
	    axios.post('courseStudy/getCourseStudy', params)
	      .then(response => {
	        resolve(response)
	      })
	      .catch(error => {
	        reject(error)
	      })
	  })
	},
	
	
	
	
}
